import { axios } from '@Root/API'

export const edit = payload => {
	return axios.put('edit/subject-module', payload)
}
